import { ColumnDef } from '@tanstack/react-table';
import { TableSelectionCell } from './TableSelectionCell';
import { TableSelectionHeader } from './TableSelectionHeader';

export const createSelectionColumn = <
    TData extends { id: string },
>(): ColumnDef<TData> => ({
    id: 'select',
    header: TableSelectionHeader,
    cell: TableSelectionCell,

    enableSorting: false,
    enableResizing: false,
    enableHiding: false,

    size: 20,
    minSize: 20,
    maxSize: 20,
});
